import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import NestedTableComponent from "components/NestedTableComponent";

const CostTrackerTable = ({
    data,
    columns,
    onRowExpand,
    loaderId,
    loading,
    error,
}) => {
    if (error) {
        return (
            <Box sx={{ p: 4, textAlign: "center" }}>
                <Typography color="error">Failed to load Cost Tracker</Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ position: "relative" }}>
            {loading && (
                <Box
                    sx={{
                        position: "absolute",
                        inset: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        bgcolor: "rgba(255,255,255,0.6)",
                        zIndex: 10,
                    }}
                >
                    <CircularProgress />
                </Box>
            )}

            <NestedTableComponent
                data={data}
                columns={columns}
                handleClick={onRowExpand}
                loaderId={loaderId}
            />
        </Box>
    );
};

export default CostTrackerTable;
